import React, { ReactNode } from 'react';
import { TrainerSelector } from '~/Components/TrainerSelector';
import { ItemCreationFieldValue } from '~/Components';

interface EventTrainerSelectionProps {
  name: string;
  selectedTrainerIds: string[];
  children: ReactNode;
  setFieldValue: ItemCreationFieldValue;
  disabled: boolean;
}

export const EventTrainerSelection = ({
  name,
  selectedTrainerIds,
  children,
  setFieldValue,
  disabled,
}: EventTrainerSelectionProps) => {
  const updateTrainerList = (ids: string[]) => {
    setFieldValue(name, ids);
  };

  return (
    <TrainerSelector
      disabled={disabled}
      selectedTrainerIds={selectedTrainerIds}
      updateTrainerList={updateTrainerList}
    >
      {children}
    </TrainerSelector>
  );
};
